import React, { forwardRef } from "react";

export const WithLabel = (WrappedInput) =>
    forwardRef(({ hint, label, ...props }, ref) => {
        const cssClass = props.className ? `form-field ${props.className}` : "form-field";
        const canDisplay = props.isReadOnly ? props.isReadOnly && !!props.defaultValue : true;

        return (
            <div className={cssClass}>
                {label && <label htmlFor={props.name}>{label}:</label>}
                <WrappedInput
                    {...props}
                    ref={ref}
                />
                {canDisplay && hint && <div className="input-hint">{hint}</div>}
            </div>
        );
    });
